import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { Check, ArrowLeft } from "lucide-react";
import { useLoadScript } from "@react-google-maps/api";
import "./teamSelectionPage.css";
import progressIcon from "../../assets/progressIcon2.png";
import heartIcon from "../../assets/heartIcon.png";
import boneIcon from "../../assets/boneIcon.png";
import nextIcon from "../../assets/nextButtonIcon.png";
import MobileTopBar from "../../components/MobileTopBar";
import MobileBottomBar from "../../components/MobileBottomBar";
import DesktopTopBar from "../../components/DesktopTopBar";
import DesktopBottomBar from "../../components/DesktopBottomBar";

const TeamSelectionPage = ({ formData, setFormData }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const { profile } = useSelector((state) => state.user);

  // Helper to update team in form data
  const handleTeamSelect = (teamName) => {
    setFormData({ ...formData, team: teamName });
  };

  const isPawsSelected = formData.team === "paws";
  const isSocialSelected = formData.team === "social";
  const isSelectionValid = isPawsSelected || isSocialSelected;

  const handleNext = () => {
    if (!isSelectionValid) return;

    setFormData((prev) => ({
      ...prev,
      dogs: [],
      dogName: "",
      dogGender: "",
      dogBirthDate: "",
      dogBreed: "",
      dogActivity: "",
      dogAgeGroup: "",
      selectedBreed1: "",
      selectedBreed2: "",
      selectedBreed3: "",
      dogPersonality: [],
      selectedTraits: "",
      selectedHobbies: "",
      availability: "",
      socialExperienceLevelWithDogs: "",
      socialExperienceWithHumans: "",
      dogPhotos: null,
      customPastime: "",
      customPromptAnswer: "",
      customPromptQuestion: "",
      customTrait: "",
      selectedPromptIndex: 0,
      rawAnswers: [],
      userBio: "",
      selectedBringsYouHere: [],
      photos: null,
    }));

    if (formData.team === "paws") {
      navigate("/dog-details");
    } else {
      navigate("/dog-social-personality", { state: { step: 1 } });
    }
  };

  return (
    <div className="ts-container">
      {/* Mobile-Only Top Header Bar */}
      <div className="ts-mobile-header">
        <MobileTopBar
          onBack={() =>
            navigate(
              location.state?.routePath ? "dashboard-switcher" : "/onboarding",
            )
          }
          backColor="#fff"
          logoColor="#fff"
          isProtectedRoute={false}
        />

        <div className="ts-progress-container mobile-only">
          <div className="ts-dog-icon-wrapper">
            <img
              src={progressIcon}
              alt="Progress Step"
              className="ts-progress-icon"
            />
          </div>
          <div className="ts-progress-track">
            <div className="ts-progress-fill"></div>
          </div>
        </div>
      </div>

      <div className="ts-left-panel">
        <div className="ts-bg-image" />
        <div className="ts-bg-overlay"></div>
        <DesktopTopBar
          showBack={true}
          onBack={() =>
            navigate(
              location.state?.routePath ? "dashboard-switcher" : "/onboarding",
            )
          }
          backColor="#000"
          showProgress={false}
        />
      </div>

      <div className="ts-right-panel">
        <DesktopTopBar
          className="sp-padding"
          showBack={false}
          showProgress={true}
          progressIconSrc={progressIcon}
          progressPercent={14}
          iconLeft={10}
          iconWidth="70px"
        />
        <div className="ts-content-wrapper">
          <h2 className="ts-step-heading">WHICH DOG LOVER ARE YOU?</h2>

          {/* Selection Buttons */}
          <div className="ts-buttons-container">
            {/* Team Paws */}
            <div className="ts-team-block">
              <div className="ts-help-row paws-row">
                <p className="ts-help-text paws-text">
                  🦴 Pup Pawrents are dog owners who want to share the joy of
                  their dogs
                </p>
                <img
                  src={boneIcon}
                  alt="Bone Icon"
                  className="ts-inline-icon paws-icon"
                />
              </div>

              <div className="ts-btn-wrapper">
                <button
                  onClick={() => handleTeamSelect("paws")}
                  className={`ts-btn ${
                    isPawsSelected ? "ts-paws-active" : "ts-inactive"
                  }`}
                >
                  <div className="ts-btn-content">
                    {isPawsSelected && (
                      <Check
                        className="ts-check-icon"
                        size={24}
                        strokeWidth={3}
                      />
                    )}
                    <span className="ts-btn-title">PUP PAWRENTS</span>
                  </div>
                </button>
              </div>
            </div>

            {/* Team Social */}
            <div className="ts-team-block">
              <div className="ts-btn-wrapper">
                <button
                  onClick={() => handleTeamSelect("social")}
                  className={`ts-btn ${
                    isSocialSelected ? "ts-social-active" : "ts-inactive"
                  }`}
                >
                  <div className="ts-btn-content">
                    {isSocialSelected && (
                      <Check
                        className="ts-check-icon"
                        size={24}
                        strokeWidth={3}
                      />
                    )}
                    <span className="ts-btn-title">PUP PALS</span>
                  </div>
                </button>
              </div>

              <div className="ts-help-row social-row">
                <img
                  src={heartIcon}
                  alt="Heart Icon"
                  className="ts-inline-icon social-icon"
                />
                <p className="ts-help-text social-text">
                  🤍 Pup Pals are non-owners who want to walk, play with, and
                  spend time with dogs
                </p>
              </div>
            </div>
          </div>

          <DesktopBottomBar
            onNext={handleNext}
            isNextEnabled={isSelectionValid}
            nextIconSrc={nextIcon}
            variant="green"
          />

          <MobileBottomBar
            onNext={handleNext}
            isNextEnabled={isSelectionValid}
            nextIconSrc={nextIcon}
            variant="green"
          />
        </div>
      </div>
    </div>
  );
};

export default TeamSelectionPage;
